import { EPaymentDirectStatus } from '../enums/direct-debit-payment.enum';

export const DIRECT_DEBIT_PAYMENT_STATUS_FILTER_OPTIONS = [
  {
    name: 'Selected',
    value: EPaymentDirectStatus.Selected,
  },
  {
    name: 'Email Sent',
    value: EPaymentDirectStatus.EmailSent,
  },
  {
    name: 'Posted',
    value: EPaymentDirectStatus.Posted,
  },
  {
    name: 'Assigned',
    value: EPaymentDirectStatus.Assigned,
  },
  {
    name: 'Submitted',
    value: EPaymentDirectStatus.Submitted,
  },
];
